import { ArchiveProgress, ArchiveStep } from './ArchiveSubsidiaryModal';
import { UserManagementStep } from './UserManagementStep';
import { InitiativePlain } from '../../../../types/initiative';
import { WarningStep } from './WarningStep';
import { ConfirmationStep } from './ConfirmationStep';
import { MinReportingLevel } from '../../types';

interface ArchiveSubsidiaryStepProps {
  archiveProgress: ArchiveProgress;
  handleChange: (changes: Partial<ArchiveProgress>) => void;
  selectedInitiative: MinReportingLevel;
  initiativeTreeList: InitiativePlain[];
  handleToggle: () => void;
  handleUpdate: () => void;
}

export const ArchiveSubsidiaryModalContent = (props: ArchiveSubsidiaryStepProps) => {
  const { archiveProgress, selectedInitiative, handleChange, handleToggle, handleUpdate, initiativeTreeList } = props;
  switch (archiveProgress.step) {
    case ArchiveStep.UserManagement:
      return (
        <UserManagementStep
          selectedInitiative={selectedInitiative}
          initiativeTreeList={initiativeTreeList}
          handleChange={handleChange}
          handleToggle={handleToggle}
        />
      );
    case ArchiveStep.Confirmation:
      return (
        <ConfirmationStep
          selectedInitiative={selectedInitiative}
          userChanges={archiveProgress.userChanges}
          handleToggle={handleToggle}
          handleUpdate={handleUpdate}
        />
      );
    case ArchiveStep.Warning:
    default:
      return <WarningStep handleChange={handleChange} handleToggle={handleToggle} />;
  }
};
